import { styled } from 'fbm-ui';
export var SvgRoot = styled('svg')({
    position: 'absolute',
    bottom: 0,
    width: '200%',
    height: '50%',
});
export var SvgGRoot = styled('g')({
    '& use': {
        animation: 'move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite',
        '&:nth-child(1)': {
            animationDelay: '-2s',
            animationDuration: '7s',
        },
        '&:nth-child(2)': {
            animationDelay: '-3s',
            animationDuration: '10s',
        },
        '&:nth-child(3)': {
            animationDelay: '-4s',
            animationDuration: '13s',
        },
        '&:nth-child(4)': {
            animationDelay: '-5s',
            animationDuration: '20s',
        },
    },
});
